import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

/**
 * This Icon Component is used to show the expand / collapse icon based on a state.
 *
 * @param isOpen Should the icon be shown as expanded?
 * @param onClick This function will be called when clicking on the icon
 * @param hover Should there be a hover effect. Default is true.
 * @param cy data-cy for cypress. Optional.
 * @returns {JSX.Element} The Icon Component
 */
export const ExpandableIcon = ({isOpen, onClick = () => {}, hover = true, cy = undefined}) => {
	return (
		<StyledDiv onClick={onClick} hover={hover} data-cy={cy}>
			{isOpen ? (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M0.175737 14.9758C-0.058579 15.2101 -0.058579 15.59 0.175737 15.8243C0.410051 16.0586 0.78995 16.0586 1.02426 15.8243L5.39999 11.4486V15C5.39999 15.3314 5.66862 15.6 5.99999 15.6C6.33137 15.6 6.59999 15.3314 6.59999 15V10C6.59999 9.66865 6.33137 9.40002 5.99999 9.40002H0.999994C0.668623 9.40002 0.399994 9.66865 0.399994 10C0.399994 10.3314 0.668623 10.6 0.999994 10.6H4.5515L0.175737 14.9758Z"
						fill="#4C4C58"
					/>
					<path
						d="M15.6 6.00002C15.6 6.3314 15.3314 6.60002 15 6.60002H9.99999C9.66862 6.60002 9.39999 6.3314 9.39999 6.00002V1.00002C9.39999 0.668654 9.66862 0.400025 9.99999 0.400025C10.3314 0.400025 10.6 0.668654 10.6 1.00002V4.55147L14.9757 0.175737C15.21 -0.058579 15.5899 -0.058579 15.8243 0.175737C16.0586 0.410051 16.0586 0.78995 15.8243 1.02426L11.4485 5.40002H15C15.3314 5.40002 15.6 5.66865 15.6 6.00002Z"
						fill="#4C4C58"
					/>
				</svg>
			) : (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M6.42426 10.4242C6.65857 10.1899 6.65857 9.81003 6.42426 9.57571C6.18994 9.3414 5.81004 9.3414 5.57573 9.57571L1.2 13.9514V10.4C1.2 10.0686 0.931371 9.8 0.6 9.8C0.268629 9.8 0 10.0686 0 10.4V15.4C0 15.7314 0.268629 16 0.6 16H5.6C5.93137 16 6.2 15.7314 6.2 15.4C6.2 15.0686 5.93137 14.8 5.6 14.8H2.0485L6.42426 10.4242Z"
						fill="#4C4C58"
					/>
					<path
						d="M10.4 -6.10352e-05C10.0686 -6.10352e-05 9.79998 0.268568 9.79998 0.599939C9.79998 0.93131 10.0686 1.19994 10.4 1.19994H13.9515L9.57572 5.5757C9.3414 5.81001 9.3414 6.18991 9.57572 6.42423C9.81003 6.65854 10.1899 6.65854 10.4242 6.42423L14.8 2.0485V5.59994C14.8 5.93131 15.0686 6.19994 15.4 6.19994C15.7313 6.19994 16 5.93131 16 5.59994V0.599939C16 0.268568 15.7313 -6.10352e-05 15.4 -6.10352e-05H10.4Z"
						fill="#4C4C58"
					/>
				</svg>
			)}
		</StyledDiv>
	);
};

ExpandableIcon.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClick: PropTypes.func,
	hover: PropTypes.bool,
	cy: PropTypes.string,
};

const StyledDiv = Styled.div`
	cursor: pointer;
	display: flex;	
	align-self: center;
	justify-content: center;
    align-items: center;
	height: 32px;
	width: 32px;
	border: 1px solid #FFFFFF;
	border-radius: 4px;
	
	${({hover}) =>
		hover &&
		`&:hover {
		background-color:#F7F7FE;
		border: 1px solid #F7F7FE;
	`}
`;
